module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2mmsL"))).then(() => parcelRequire('1iHdE'));